module.exports = __webpack_public_path__ + "static/search-dab82df80abfb3460082c8c489ff36f2.png";